/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @flow
 */
import {NullComponent} from './NullComponent.js';
import {withSideEffect} from './PreactSideEffect.js';

/*:: type Props = {+title: string}; */
/*:: type State = string; */

function reducePropsToState(propsList /*: Props[] */) /*: State */ {
  const innermostProps = propsList[propsList.length - 1];

  if (innermostProps) {
    return innermostProps.title;
  }
  return '';
}

function handleStateChangeOnClient(title /*: State */) /*: void */ {
  if (title !== document.title) {
    document.title = title;
  }
}

export const DocumentTitle /*: React$Component<Props, State> */ = withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient
)(NullComponent);
